import { tv } from '@change/ds-utils';

export const BodyStyles = tv({
	base: 'bg-background-base object-fill',
	variants: {
		size: {
			small: 'h-[125px] w-[100px]',
			medium: 'h-[250px] w-[200px]',
			large: 'h-[291px] w-[233px]',
		},
	},
});
